export enum SUIVI {
  SUI_INS_CODE = 'SUI_INS',
  SUI_TRAT_CODE = 'SUI_TRA',
  SUI_CONS_CODE = 'SUI_CON'

}
